import Carousel from '../Carousel/Carousel';
import DisplayCase from './DisplayCase';
import './DisplayCase.css';

/**
 * @param {*} exhibits A dictionary of dictionaries with the following keys:
 * - **`image`:** The image URL for the exhibit
 * - **`title`:** The title of the exhibit
 * - **`origin`:** The origin of the exhibit
 * - **`description`:** A description of the exhibit
 * @returns A Museum of DisplayCases
 */
export default function Museum({ exhibits }) {
	const slides = exhibits.map((exhibit) => (
		<DisplayCase key={exhibit.title} exhibit={exhibit} />
	));
	return (
		<div className="display-case-wrapper">
			<Carousel elements={slides} scrollSeconds={8} />
		</div>
	);
}
